import { SVGProps } from 'react'

export const Selected = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.576172 3.18608L4.06384 6.64492L9.29533 0.303711"
        stroke="white"
        strokeWidth="0.792651"
      />
    </svg>
  )
}
